import React, { useMemo } from 'react';
import ScheduleItem from './ScheduleItem';
import { calculateProgress } from '../../../../src/common/utils/liveUtil';

const ScheduleList = React.memo(
  ({
    channelId,
    schedulesGrouped,
    alarms,
    onAlarmToggle,
    jwtToken,
    thumbnailImage,
    formatDateTime,
    formatDateLabel,
  }) => {
    const checkAlarmStatus = useMemo(() => {
      return (schedule) => {
        if (!jwtToken) return false; // 로그인 안되어 있으면 알람 상태 확인 안함
        const yyyymmdd_hhmm = formatDateTime(schedule.starttime_date);
        const alarmKey = `${channelId}_${yyyymmdd_hhmm}`;
        return !!alarms[alarmKey];
      };
    }, [alarms, channelId, formatDateTime]);

    return (
      <div className="schedule_table_w">
        {schedulesGrouped !== null &&
          Object.entries(schedulesGrouped).map(
            ([dateKey, schedules], index) => {
              const scheduleDate = new Date(dateKey);
              const today = new Date();
              const tomorrow = new Date(today);
              tomorrow.setDate(tomorrow.getDate() + 1);

              let dateLabel,
                isWeekday = false;
              if (scheduleDate.toDateString() === today.toDateString()) {
                dateLabel = formatDateLabel(today) + '오늘';
              } else {
                isWeekday = true;
                dateLabel = formatDateLabel(tomorrow, isWeekday);
              }

              return (
                <React.Fragment key={dateKey}>
                  <div className="schedule_title_con02">
                    <strong>{dateLabel}</strong>
                  </div>
                  {schedules.map((schedule, index) => {
                    let isShowDVR = ['S01', 'S02', 'S05', 'S06'].includes(
                      channelId
                    );
                    let isNow = false;
                    let button = '';

                    if (schedule.status && isShowDVR) {
                      isShowDVR = true;
                    } else {
                      isShowDVR = false;
                    }
                    if (schedule.status == 'past') {
                      if (isShowDVR) button = 'dvr';
                      isNow = false;
                    } else if (schedule.status == 'now') {
                      isNow = true;
                    } else {
                      button = 'alarm';
                      isNow = false;
                    }

                    const labels = [];
                    if (schedule.broad_code2?.substring(0, 1) == '1')
                      labels.push('재');
                    if (schedule.broad_code2?.substring(2, 3) == '1')
                      labels.push('자');
                    if (schedule.broad_code2?.substring(3, 4) == '1')
                      labels.push('해');
                    if (schedule.broad_code2?.substring(4, 5) == '1')
                      labels.push('수');
                    if (schedule.broad_code2?.substring(5, 6) == '1')
                      labels.push('M');
                    if (schedule.live_flag == '1') labels.push('HD');
                    if (schedule.live_flag == '2') labels.push('본');
                    if (schedule.onair_flag == '2') labels.push('NO-ON');
                    if (schedule.target_age > 0)
                      labels.push(schedule.target_age);
                    if (schedule.target_age == 0) labels.push('All');
                    if (schedule.is_bora == 'Y') labels.push('보라');

                    const progress = schedule.current
                      ? calculateProgress(schedule.starttime, schedule.endtime)
                      : 0;

                    const isAlarmActive = checkAlarmStatus(schedule);

                    return (
                      <>
                        <ScheduleItem
                          key={schedule.status + '_' + index}
                          isAlarmActive={isAlarmActive}
                          onAlarmToggle={(isActive) =>
                            onAlarmToggle(
                              schedule.channelId,
                              schedule.date,
                              isActive
                            )
                          }
                          jwt={jwtToken}
                          date={formatDateTime(schedule.starttime_date)}
                          channel_id={channelId}
                          circle_image={schedule.circle_image || ''}
                          smr_programid={schedule.programId}
                          thumbnail={thumbnailImage}
                          time={schedule.starttime}
                          title={schedule.title}
                          labels={labels}
                          isLive={isNow}
                          button={button}
                          progress={progress}
                        />
                        {schedule.current ? (
                          <div className="schedule_contents_ad">
                            <div className="ad_banner_w">
                              <iframe
                                title="배너광고"
                                src="/html/m/live_mo_middle_320100.htm"
                                width="320"
                                height="100"
                                scrolling="no"
                                allowtransparency="ture"
                                style={{ border: 0, margin: '0px' }}
                              ></iframe>
                            </div>
                          </div>
                        ) : null}
                      </>
                    );
                  })}
                </React.Fragment>
              );
            }
          )}
        {schedulesGrouped !== null &&
          Object.keys(schedulesGrouped).length === 0 && (
            <div className="nodata_w">
              <div className="nodata_inner">
                <div className="nodata_img">
                  <img src="/images/img_nodata.png" alt="편성정보 없음" />
                </div>
                <p className="nodata_text">표시할 내용이 없습니다</p>
              </div>
            </div>
          )}
      </div>
    );
  }
);

export default ScheduleList;
